import { CircularProgress, Stack, Typography } from '@mui/material';

import { AlertTriangleFilledIcon } from '@/components/icons/AlertTriangleFilledIcon';
import { COLORS } from '@/styles/tokens/colors';

export function ChatLoadingState() {
  return (
    <Stack
      data-testid="chat-loading-state"
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 1,
      }}
    >
      <CircularProgress
        size={14}
        sx={{
          color: COLORS.TEAL[600],
        }}
      />
      <Typography
        variant="body-xs"
        sx={{
          color: COLORS.TEAL[600],
          fontWeight: 500,
        }}
      >
        Thinking...
      </Typography>
    </Stack>
  );
}

interface ChatErrorStateProps {
  error?: string | null;
}

export function ChatErrorState({ error }: ChatErrorStateProps) {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 1,
      }}
    >
      <AlertTriangleFilledIcon
        size={16}
        sx={{
          color: COLORS.FUNCTIONAL.ERROR[600],
        }}
      />
      <Typography
        variant="body-xs"
        sx={{
          color: COLORS.FUNCTIONAL.ERROR[600],
          fontWeight: 500,
        }}
      >
        {error || 'Something went wrong, try again'}
      </Typography>
    </Stack>
  );
}
